<template>
  <div>
    <div v-if="entry.name">
      <review-show-entry :entry="entry"/>
    </div>
    <!-- v-if -->
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import ReviewShowEntry from '@/components/review/ReviewShowEntry.vue'

export default {
  components: { ReviewShowEntry },
  data() {
    return {
      entry: {}
    }
  },
  methods: {
    nextPrev(incrementDecrement) {
      let entriesArray = Object.keys(this.entries)
      let index = this.currentEntry(this.$route.params.ceid)
      index !== -1
        ? this.$router.push({
            name: 'completed-entry',
            params: { ceid: entriesArray[index + incrementDecrement] }
          })
        : this.$router.push({ name: 'completed-entries' })
      window.scrollTo(0, 0)
    }
  },
  computed: {
    ...mapState({
      // entrants: state => state.admin.entrands
      entries: state => state.review.entries
    }),
    ...mapGetters({
      entryCount: 'review/entryCount',
      currentEntry: 'review/currentEntry'
    }),
    entryIndex: function() {
      let entriesArray = Object.keys(this.entries)
      let index = entriesArray.findIndex(
        needle => needle == this.$route.params.ceid
      )
      return index
    }
  },
  mounted() {
    let key = this.$route.params.ceid
    // console.log(this.entries[key])
    this.entry = this.entries[key]
    console.log(this.entries[key])
  }
}
</script>

<style scoped lang="scss">
.nav-review-wrapper {
  position: fixed;
  z-index: 1200;
  right: 0;
  bottom: 0;

  width: 220px;
  .nav-review-controls {
    height: 58px;
    border-top: 1px solid rgba(150, 150, 150, 0.1);
    background-color: rgba(0, 0, 0, 0.05);
    .counter {
      color: rgb(230, 230, 230);
      font-size: 0.8em;
      font-weight: 200;
    }
  }
  .nav-review-buttons {
    height: 80px;
    border-top: 1px solid rgba(100, 100, 100, 0.1);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    background-color: rgba(0, 0, 0, 0.05);
  }
  .btn {
    /* box-shadow: 2px 0px 6px 3px rgba(0, 0, 0, 0.1) !important;*/
  }
  .nav-review-comments {
    border-top: 1px solid rgba(150, 150, 150, 0.2);
    .nav-review-sub-heading {
      color: rgba(255, 255, 255, 0.7);
    }
    textarea#comment {
      background: none;
      color: rgba(255, 255, 255, 0.7);
      font-weight: 200;
      border: none;
      box-shadow: none;
      + :focus {
        box-shadow: none;
        border: none;
      }
    }
  }
}
@media (min-width: 768px) {
}
</style>
